/*============================================================================
  (c) Copyright 2014 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart

  Ajaxify the add to cart experience and flip the button for inline confirmation,
  show the cart in a modal, or a 3D drawer.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajaxify cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  JQUERY API (c) Copyright 2009-2014 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  Includes slight modifications to addItemFromForm.
==============================================================================*/

/*============================================================================
  This file includes modifications from the base ajaxify.js file included with 
  the timber framework. These modifications include the entire fixed nav drawer
  functionality.

  Modifications by: Steve Puddick   
==============================================================================*/



if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  Basic JS Helper Functions
==============================================================================*/
function urlParams (name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onProduct = function(product) {
  // alert('Received everything we ever wanted to know about ' + product.title);
};

Shopify.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};
 
/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1,
      params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};

// GET products/<product-handle>.js returns the product in JSON
Shopify.getProduct = function(handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if ((typeof callback) === 'function') {
      callback(product);
    }
    else {
      Shopify.onProduct(product);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
Shopify.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module, $) {

  'use strict';

  // Public functions
  var init;

  // Private general variables
  var settings, cartInit, $drawerHeight, $cssTransforms, $cssTransforms3d, $nojQueryLoad, $w, $body, $html;

  // Private plugin variables
  var $formContainer, $btnClass, $wrapperClass, $addToCart, $flipClose, $flipCart, $flipContainer, $cartCountSelector, $cartCostSelector, $toggleCartButton, $modal, $cartContainer, $drawerCaret, $modalContainer, $modalOverlay, $closeCart, $drawerContainer, $prependDrawerTo, $callbackData={};

  // Private functions
  var updateCountPrice, flipSetup, revertFlipButton, modalSetup, showModal, sizeModal, hideModal, drawerSetup, showDrawer, hideDrawer,  sizeDrawer, loadCartImages, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, setToggleButtons, flipCartUpdateCallback, buildCart, cartTemplate, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, scrollTop, toggleCallback, toggleButtonClickCallback;

  //variables introduced in extension of ajaxify.js for the multiface theme
  var curPanelID, $toggleMenuButton, $toggleSearchButton, $toggleNoticeButton, $toggleCustomerButton,  $drawerPanels,  $innerDrawerSelector, $toggleButtons, transitionEvents, $html, $body, $cssTransitions, tabElements, deviceTouch, $drawerSlideContainer, transformPrefix;

  //private functions introduced in extension of ajaxify.js for the multiface theme
  var hideShowDrawer, scrollPosRevert, scrollRevert, setToggleButtonSpanTrigger, drawerAction;


  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      method: 'drawer', // Method options are drawer, modal, and flip. Default is drawer.
      formSelector: 'form[action^="/cart/add"]',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      toggleCartButton: null,
      btnClass: null,
      wrapperClass: null,
      useCartTemplate: true,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true,
      prependDrawerTo: 'body',
      onToggleCallback: null,
      drawerPanelsSelector: null,
      toggleMenuButton:null,
      toggleSearchButton:null,
      toggleNoticeButton:null,
      toggleCustomerButton:null,
      innerDrawerSelector:null,
      toggleButtonsSelector:null,
      drawerSlideContainer:null
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // If method parameter is set, override the defined method (used for demos)
    if (urlParams('method')) {
      settings.method = urlParams('method');
    }

    // Make sure method is lower case
    settings.method = settings.method.toLowerCase();

    // Select DOM elements
    $formContainer        = $(settings.formSelector);
    $btnClass             = settings.btnClass;
    $wrapperClass         = settings.wrapperClass;
    $addToCart            = $formContainer.find(settings.addToCartSelector);
    $flipContainer        = null;
    $flipClose            = null;
    $cartCountSelector    = $(settings.cartCountSelector);
    $cartCostSelector     = $(settings.cartCostSelector);
    $toggleCartButton     = $(settings.toggleCartButton);
    $modal                = null;
    $prependDrawerTo      = $(settings.prependDrawerTo);
    $drawerPanels         = $(settings.drawerPanelsSelector);
    $toggleMenuButton     = $(settings.toggleMenuButton);
    $toggleSearchButton   = $(settings.toggleSearchButton);
    $toggleNoticeButton   = $(settings.toggleNoticeButton);
    $toggleCustomerButton = $(settings.toggleCustomerButton);
    $innerDrawerSelector  = $(settings.innerDrawerSelector);
    $toggleButtons        = $(settings.toggleButtonsSelector);
    $drawerSlideContainer = $(settings.drawerSlideContainer);

    $html             = $('html');
    $body             = $('body');
    transitionEvents  = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";
    tabElements       = 'a, input, select, button, textarea';
    transformPrefix		= ["transform", "-webkit-transform", "-ms-transform", "-moz-transform", "-o-transform"];

    // CSS Checks
    $cssTransitions   = Modernizr.csstransitions;
    $cssTransforms    = Modernizr.csstransforms;
    $cssTransforms3d  = Modernizr.csstransforms3d;
    deviceTouch      	= Modernizr.touch;

    // General Selectors
    $w    = $(window);
    $body = $('body');
    $html = $('html');

    // Check if we can use .load
    $nojQueryLoad = $html.hasClass('lt-ie9');
    if ($nojQueryLoad) {
      settings.useCartTemplate = false;
    }

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Enable the ajax cart
    if (!settings.disableAjaxCart) {
      // Handle each case add to cart method
      switch (settings.method) {
        case 'flip':
          flipSetup();
          break;

        case 'modal':
          modalSetup();
          break;

        case 'drawer':
          drawerSetup();
          break;
      }

      // Escape key closes cart
      $(document).keyup(function (evt) {
        if (evt.keyCode == 27) {
          switch (settings.method) {
            case 'flip':
            case 'drawer':
              hideDrawer();
              break;
            case 'modal':
              hideModal();
              break;
          }
        }
      });

      if ($addToCart.length) {
        // Take over the add to cart form submit
        formOverride();
      }
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  flipSetup = function () {
    // Build and append the drawer in the DOM
    drawerSetup();

    // Stop if there is no add to cart button
    if (!$addToCart.length) {
      return
    }

    // Wrap the add to cart button in a div
    $addToCart.addClass('flip__front').wrap('<div class="flip"></div>');

    // Write a (hidden) Checkout button, a loader, and the extra view cart button
    var checkoutBtn = $('<a href="/cart" class="flip__back" style="background-color: #C00; color: #fff;" class="flip__checkout">Checkout</a>').addClass($btnClass),
        flipLoader = $('<span class="ajaxcart__flip-loader"></span>'),
        flipExtra = $('<div class="flip__extra"><a href="#" class="flip__cart">View Cart (<span></span>)</a></div>');

    // Append checkout button and loader
    checkoutBtn.insertAfter($addToCart);
    flipLoader.insertAfter(checkoutBtn);

    // Setup new selectors
    $flipContainer = $('.flip');

    if (!$cssTransforms3d) {
      $flipContainer.addClass('no-transforms')
    }

    // Setup extra selectors once appended
    flipExtra.insertAfter($flipContainer);
    $flipCart = $('.flip__cart');

    $flipCart.on('click', function(e) {
      e.preventDefault();
      showDrawer(true);
    });

    // Reset the button if a user changes a variation
    $('input[type="checkbox"], input[type="radio"], select', $formContainer).on('click', function() {
      revertFlipButton();
    })
  };

  revertFlipButton = function () {
    $flipContainer.removeClass('is-flipped');
  };

  modalSetup = function () {
    // Create modal DOM elements with handlebars.js template
    var source   = $("#ModalTemplate").html(),
        template = Handlebars.compile(source);

    // Append modal and overlay to body
    $body.append(template).append('<div class="ajaxcart__overlay"></div>');

    // Modal selectors
    $modalContainer = $('#AjaxifyModal');
    $modalOverlay   = $('.ajaxcart__overlay');
    $cartContainer  = $('#AjaxifyCart');

    // Close modal when clicking the overlay
    $modalOverlay.on('click', hideModal);

    // Create a close modal button
    $modalContainer.prepend('<button class="ajaxcart__close" title="Close Cart">Close Cart</button>');
    $closeCart = $('.ajaxcart__close');
    $closeCart.on('click', hideModal);

    // Add a class if CSS translate isn't available
    if (!$cssTransforms) {
      $modalContainer.addClass('no-transforms')
    }

    // Update modal position on screen changes
    $(window).on({
      orientationchange: function(e) {
        if ($modalContainer.hasClass('is-visible')) {
          sizeModal('resize');
        }
      }, resize: function(e) {
        // IE8 fires this when overflow on body is changed. Ignore IE8.
        if (!$nojQueryLoad && $modalContainer.hasClass('is-visible')) {
          sizeModal('resize');
        }
      }
    });

    // Toggle modal with cart button
    setToggleButtons();
  };

  showModal = function (toggle) {
    $body.addClass('ajaxcart--is-visible');
    // Build the cart if it isn't already there
    if (!cartInit && toggle) {
      Shopify.getCart(cartUpdateCallback);
    } else {
      sizeModal();
    }
  };

  sizeModal = function(isResizing) {
    if (!isResizing) {
      $modalContainer.css('opacity', 0);
    }

    // Position modal by negative margin
    $modalContainer.css({
      'margin-left': - ($modalContainer.outerWidth() / 2),
      'opacity': 1
    });

    // Position close button relative to title
    $closeCart.css({
      'top': 10 + ($cartContainer.find('h1').height() / 2)
    })

    $modalContainer.addClass('is-visible');

    scrollTop();

    toggleCallback({
      'is_visible': true
    });
  };

  hideModal = function (e) {
    $body.removeClass('ajaxcart--is-visible');
    if (e) {
      e.preventDefault();
    }

    if ($modalContainer) {
      $modalContainer.removeClass('is-visible');
      $body.removeClass('ajaxify-lock');
    }

    toggleCallback({
      'is_visible': false
    });
  };

  drawerSetup = function () {
    // Create drawer DOM elements with handlebars.js template
    var source   = $("#DrawerTemplate").html(),
        template = Handlebars.compile(source),
        data = {
          wrapperClass: $wrapperClass
        };

    // Append drawer (defaults to body)
    $prependDrawerTo.prepend(template(data));

    // Drawer selectors
    $drawerContainer = $('#AjaxifyDrawer');
    $cartContainer   = $('#AjaxifyCart');
    $drawerCaret     = $('.ajaxcart__caret > span');

    $drawerPanels  = $(settings.drawerPanelsSelector);
    $innerDrawerSelector = $(settings.innerDrawerSelector);
    
    //for accessibility all of the focusable elements in the drawer are not focusable on initialize
    $drawerPanels.find(tabElements).attr('tabIndex', '-1');

    /**
    *
    * As a consequence of using 'creative' css to allow for transitions on background gradients, 
    * toggle buttons must target the span child element otherwise it creates accessibility problems 
    * with keypress events.
    *
    **/
    $toggleButtons = $(settings.toggleButtonsSelector).children('span');

    // Toggle drawer with cart button
    setToggleButtons();

    // Position caret and size drawer on resize if drawer is visible
    var timeout;
    $(window).resize(function() {
      clearTimeout(timeout);
      timeout = setTimeout(function(){
        if ($drawerContainer.hasClass('is-visible')) {
          positionCaret();
          sizeDrawer();
        }
      }, 500);
    });

    // Position the caret the first time
    positionCaret();

    // Position the caret
    function positionCaret() {
      if ($toggleCartButton.offset()) {
        // Get the position of the toggle button to align the caret with
        var togglePos = $toggleCartButton.offset(),
            toggleWidth = $toggleCartButton.outerWidth(),
            toggleMiddle = togglePos.left + toggleWidth/2;

        $drawerCaret.css('left', toggleMiddle + 'px');
      }
    }
  };

  showDrawer = function (toggle, show_panel_id) {
    /**
    *
    * The transition event callback is separated into a named function so it can be called 
    * on the 'transition end' event when CSS transitions are supported, and manually when 
    * CSS transitions are not supported.
    *
    **/
    
    var transitionEnd = function() {
      
      /**
       *
       * all focusable elements are set to non-focusable via 'tabIndex = -1' for accessibility reasons.
       * We don't want hidden elements to be focusable
       *
       **/
      $drawerPanels.find(tabElements).attr('tabIndex', '-1');
       
      //The focusable elements on the active panel are allowed to be focusable
      $('#' + show_panel_id).find(tabElements).removeAttr('tabIndex'); 
      
      //once the transition event is complete the toggle buttons are functional again
      $toggleButtons.on('click', toggleButtonClickCallback);

      if ($html.getNiceScroll()) {
        $html.getNiceScroll().resize();
      }

    }

    if ($cssTransitions) {
      
      $drawerSlideContainer.on(transitionEvents, function(e) {
        if (  $.inArray(e.originalEvent.propertyName, transformPrefix) >= 0 ) {
          /**
           *
           * There could be multiple css properties with a transition set.
           * We need to make sure we are responding only to the height transition event
           *
           **/
           
           
          /**
           *
           * We only want this event to fire once after being bound to the element so we remove the event listener
           * We can't use the Jquery 'one' method since we are interested in just the height transition end event
           *
           **/
         $(e.target).off(transitionEvents);
         
         transitionEnd();
        }
      });

    } else {
      transitionEnd();
    }

    /**
     *
     * Each panel has the id of it's corresponding button in a data attributie
     * We look for this and add the 'active' class. This highlights the button to show
     * it is active 
     *
     **/
    $($('#' + show_panel_id).data('fixed-nav-button-id')).addClass('active');
    
    //Hide all of the panels
    $drawerPanels.addClass('visuallyhidden');

    if (typeof show_panel_id !== "undefined") {
      //show the specific panel that is being activated

      $('#' + show_panel_id).removeClass('visuallyhidden');
    }

    // If we're toggling with the flip method, use a special callback
    if (settings.method == 'flip') {
      Shopify.getCart(flipCartUpdateCallback);
    }

    // opening the drawer for the first time
    else if (!cartInit && toggle) {
      Shopify.getCart(cartUpdateCallback);
    }

    // simple toggle? just size it
    else if (cartInit && toggle) {
      sizeDrawer();
    }

    // Show the drawer
    $drawerContainer.addClass('is-visible');
    $body.addClass('drawer-active');
    scrollTop();

    toggleCallback({
      'is_visible': true
    });
  };
  
  hideShowDrawer = function (show_panel_id) {
    /**
    *
    * This function has been introduced to handle scenarios where a drawer is currently active
    * but another drawer panel has been activated. The old drawer is hidden. At the moment it is fully 
    * hidden the new panel is 'switched in' and the drawer is revealed again
    *
    **/ 
    
    var transitionEnd = function() {
        
        //for accessibility, we set all focusable elements to non-focusable when the drawer is hidden
        $drawerPanels.find(tabElements).attr('tabIndex', '-1');
        toggleCallback({
          'is_visible': false
        });

        //we show the new panel
        showDrawer(true, show_panel_id);      
    }

    $toggleButtons.parent().removeClass('active');

    if ($cssTransitions && $cssTransforms3d) {
      $drawerSlideContainer.on(transitionEvents, function(e) {
        
        if (  $.inArray(e.originalEvent.propertyName, transformPrefix) >= 0 ) {
          //console.log('showhide drawer');
          /**
          *
          * We are listening for only the height transition event. Other CSS transition properties may be present.
          * We only want this event to fire once after being bound. jQuery's 'one' method will not work here due to multiple 
          * css transition properties which may be present
          *
          **/
          $(e.target).off(transitionEvents); 
          
          transitionEnd();
        }

      });
    } else {
      transitionEnd();
    }            

    $drawerSlideContainer.removeAttr('style');
    $drawerContainer.removeAttr('style').removeClass('is-visible');

  };

  hideDrawer = function () {

    /**
    *
    * We express the transition event callback into a named function so we can access it from both the 
    * actual transition event, and manually if the browser does not support CSS transition
    *
    **/
    var transitionEnd = function() {

      //Different parts of the web page are reset after the drawer is hidden     
      $drawerPanels.find(tabElements).attr('tabIndex', '-1');
      $drawerPanels.addClass('visuallyhidden');
      scrollRevert();
      $body.removeClass('drawer-active');      
      $toggleButtons.on('click', toggleButtonClickCallback);

      if ($html.getNiceScroll()) {
        $html.getNiceScroll().resize();
      }

    }

    $toggleButtons.parent().removeClass('active');

    if ($cssTransitions) {
      $drawerSlideContainer.on(transitionEvents, function(e) {
        if (  $.inArray(e.originalEvent.propertyName, transformPrefix) >= 0 ) {
          //console.log('hiding drawer');
          $(e.target).off(transitionEvents);
            transitionEnd();

        }
      });      
    } else {
      transitionEnd();
    }

    $drawerSlideContainer.removeAttr('style');
    $drawerContainer.removeAttr('style').removeClass('is-visible');
    
    toggleCallback({
      'is_visible': false
    });
    
  }; 

  sizeDrawer = function ($empty) { 
    if ($empty) {
      $drawerContainer.addClass('drawer-transition-ready');
      $drawerContainer.css('height', '0px');
      $innerDrawerSelector.css('height', '0px');
      $drawerSlideContainer.attr('style', '');

      //$('#drawer-background-underlay').css('height', '0px');
    } else {
       
      /**
      *
      * $extraHeight is used to hold the top padding, margin, and border amounts which may be present 
      * on the drawer and panel. This value is needed to calculate the overall offset that is needed
      *
      **/
      var $extraHeight;
      $drawerContainer.removeClass('drawer-transition-ready');
      $extraHeight = $drawerContainer.outerHeight() - $drawerContainer.height();
      $extraHeight += $innerDrawerSelector.outerHeight() - $innerDrawerSelector.height();
      
      $drawerHeight = $('#' + curPanelID).outerHeight() + $extraHeight;
      $drawerContainer.addClass('drawer-transition-ready');
      $('.cart__row img').css('width', 'auto'); // fix Chrome image size bug
      
      $drawerContainer.css('height', $drawerHeight + 'px');
      $innerDrawerSelector.css('height', $drawerHeight + 'px');

      //$('#drawer-background-underlay').css('height', $drawerHeight + 'px');
     	
     	$drawerSlideContainer.css('transform', 'translateY('+ $drawerHeight +'px)');
      $drawerSlideContainer.css('-ms-transform', 'translateY('+ $drawerHeight +'px)');
      $drawerSlideContainer.css('-webkit-transform', 'translateY('+ $drawerHeight +'px)');

      //$drawerContainer.css('height',  '400px');

    }
  };

  loadCartImages = function () {
    // Size cart once all images are loaded
    var cartImages = $('img', $cartContainer),
        count = cartImages.length,
        index = 0;

    cartImages.on('load', function() {
      index++;

      if (index==count) {
        switch (settings.method) {
          case 'modal':
            sizeModal();
            break;
          case 'flip':
          case 'drawer':
            sizeDrawer();
            break;
        }
      }
    });
  };

  formOverride = function () {
    $formContainer.submit(function(e) {
      e.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      Shopify.addItemFromForm(e.target, itemAddedCallback, itemErrorCallback);

      // Set the flip button to a loading state
      switch (settings.method) {
        case 'flip':
          $flipContainer.addClass('flip--is-loading');
          break;
      }
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    // Slight delay of flip to mimic a longer load
    switch (settings.method) {
      case 'flip':
        setTimeout(function () {
          $flipContainer.removeClass('flip--is-loading').addClass('is-flipped');
        }, 600);
        break;
    }
    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');

    switch (settings.method) {
      case 'flip':
        $flipContainer.removeClass('flip--is-loading');
        break;
    }

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    switch (settings.method) {
      case 'flip':
        $('.flip__cart span').html(cart.item_count);
        break;
      case 'modal':
        buildCart(cart);
        break;
      case 'drawer':
        buildCart(cart);

        break;
    }
  };

  drawerAction = function(newPanelID) {
    //we separate the drawer action from the click callback because this may be called manually when the 'Add to Cart' button is clicked

    if ($drawerContainer.hasClass('is-visible')) {
      //if the drawer is currently being displayed (regardless of panel)
      
      if (curPanelID != newPanelID) {
        //if the new panel to be displayed is not the currently displayed panel

        curPanelID = newPanelID;
        hideShowDrawer(newPanelID);
      
      } else {
        //if the new panel to be displayed is the same as the currently displayed panel

        curPanelID = null;
        hideDrawer();
      }
      
    } else {
      //if the drawer is currently closed

      curPanelID = newPanelID;
      
      //we record the scroll position so we know where to scroll back to when the drawer is closed.
      scrollPosRevert = $(window).scrollTop();
      showDrawer(true, newPanelID);
    }
  }

  toggleButtonClickCallback = function(e) {
    e.preventDefault();
    e.stopPropagation();
    /**
    *
    * If a toggle button is clicked during a CSS transition it can cause unpredictable results.
    * This is due to the event listeners bound to the 'transition end' event. After a toggle button is 
    * clicked, the click event listener is removed. This presents new (undesirable) transition events firing before older
    * ones have completed. The click event is bound again once the transition event is complete, in another function.
    *
    **/
    $toggleButtons.off('click');
    
    switch (settings.method) {
      //This customized version of ajaxify.js only uses the 'drawer' display method.

      case 'modal':
        if ($modalContainer.hasClass('is-visible')) {
          hideModal();
        } else {
          showModal(true);
        }
        break;
      case 'drawer':
      case 'flip':
        
        //We determine which panel should be shown by looking at the data attribute of the button clicked
        var newPanelID = $(e.target).parent().data('ajaxify-panel-id');                

        drawerAction(newPanelID);

        break;
    }
   
  }

  setToggleButtonSpanTrigger = function(e) {
    /**
    *
    * Due to how the toggle button markup and css is structured (to simulate transitions on background gradients)
    * We need to have event listeners on the toggle button, and the toggle button 'span' child element. Otherwise this 
    * creates accessibility issues since the buttons can't be triggered with focus and the 'enter' keypress.
    * 
    **/
    
    var toggleAnchor = $(e.target);
    
    /**
    *
    * To prevent an infinite loop of events firing we deregister the event listener before we manually trigger the click event
    * on the child span element 
    *
    **/ 

    if (e.which == 13) {
      //if enter pressed
      
      //e.preventDefault();
      toggleAnchor.off('keydown');
      toggleAnchor.children('span').trigger('click');
      toggleAnchor.on('keydown', setToggleButtonSpanTrigger);
    }

  } 

  setToggleButtons = function () {
    
    //due to the 'creative' css used to simulate css transitions on background gradients, we need to target the child span tag
    $toggleButtons = $(settings.toggleButtonsSelector).children('span');
    
    $addToCart = $formContainer.find(settings.addToCartSelector);
    
    if (!deviceTouch) {
      /**
      *
      * There is a slight delay after the toggle buttons are pressed on touch devices. It is suspected this could be
      * due to the keypress event binding on the child span element. This event binding is not needed on touch devices.
      * Although it is thought that touch devices will ignore keypress events, they may try to similute keypress events
      * with touch events. This will need to be investigated further. 
      *
      **/
      
      //For accessibility, we have a keydown event binding (which checked for 'enter') on the child span element. 
      //Because of how we are simulating transitions on background gradients this is necessary.  
      $toggleButtons.parent().on('keydown', setToggleButtonSpanTrigger);
    }
    
    // Turn it off by default, in case it's initialized twice
    $toggleButtons.off('click');

    // Toggle the cart, based on the method
    $toggleButtons.on('click', toggleButtonClickCallback);

  
    $addToCart.off('click');

    // Toggle the cart, based on the method
    $addToCart.on('click', function(e) {
      if ($('#AjaxifyCart').hasClass('visuallyhidden')) {
        //$toggleCartButton.trigger('click');
        drawerAction('AjaxifyCart');
      } else {
        scrollTop();
      }

    });

  };

  flipCartUpdateCallback = function (cart) {
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Empty cart if using default layout or not using the .load method to get /cart
    if (!settings.useCartTemplate || cart.item_count === 0) {
      $cartContainer.empty();
    }

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<h2>' + "Your cart is currently empty." + '</h2>')
        .append('<p>' + "Continue browsing \u003ca href=\"\/collections\/all\"\u003ehere\u003c\/a\u003e." + '</p>');

      switch (settings.method) {
        case 'modal':
          sizeModal('resize');
          break;
        case 'flip':
        case 'drawer':
          sizeDrawer();

          break;
      }
      return;
    }

    // Use the /cart template, or Handlebars.js layout based on theme settings
    if (settings.useCartTemplate) {
      cartTemplate(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {}
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      var itemAdd = cartItem.quantity + 1,
          itemMinus = cartItem.quantity - 1,
          itemQty = cartItem.quantity;

      /* Hack to get product image thumbnail
       *   - Remove file extension, add _small, and re-add extension
       *   - Create server relative link
      */
      var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', ''),
          prodName = cartItem.title.replace(/(\-[^-]*)$/, ""),
          prodVariation = cartItem.title.replace(/^[^\-]*/, "").replace(/-/, "");

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        url: cartItem.url,
        img: prodImg,
        name: prodName,
        variation: prodVariation,
        itemAdd: itemAdd,
        itemMinus: itemMinus,
        itemQty: itemQty,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat)
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      btnClass: $btnClass
    }
    $cartContainer.append(template(data));

    // With new elements we need to relink the adjust cart functions
    adjustCart();

    // Setup close modal button and size drawer
    switch (settings.method) {
      case 'modal':
        loadCartImages();
        break;
      case 'flip':
      case 'drawer':
        if (cart.item_count > 0) {
          loadCartImages();
        } else {
          sizeDrawer(true);
        }
        break;
      default:
        break;
    }

    // Mark the cart as built
    cartInit = true;
  };

  cartTemplate = function (cart) {
    var url = '/cart?' + Date.now() + ' form[action="/cart"]';
    $cartContainer.load(url, function() {

      // With new elements we need to relink the adjust cart functions
      adjustCart();

      // Size drawer at this point
      switch (settings.method) {
        case 'modal':
          loadCartImages();
          break;
        case 'flip':
        case 'drawer':
          if (cart.item_count > 0) {
            loadCartImages();
          } else {
            sizeDrawer(true);
          }
          break;
        default:
          break;
      }

      // Mark the cart as built
      cartInit = true;
    });
  }

  adjustCart = function () {
    // This function runs on load, and when the cart is reprinted

    // Create ajax friendly quantity fields and remove links in the ajax cart
    if (settings.useCartTemplate) {
      createQtySelectors();
    }

    // Update quantify selectors
    var qtyAdjust = $('.ajaxcart__qty-adjust');

    // Add or remove from the quantity
    qtyAdjust.off('click');
    qtyAdjust.on('click', function() {
      var el = $(this),
          id = el.data('id'),
          qtySelector = el.siblings('.ajaxcart__qty-num'),
          qty = parseInt(qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if (el.hasClass('ajaxcart__qty--plus')) {
        qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-id, update the cart.
      // Otherwise, just update the input's number
      if (id) {
        updateQuantity(id, qty);
      } else {
        qtySelector.val(qty);
      }

    });

    // Update quantity based on input on change
    var qtyInput = $('.ajaxcart__qty-num');
    qtyInput.off('change');
    qtyInput.on('change', function() {
      var el = $(this),
          id = el.data('id'),
          qty = parseInt(el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Only update the cart via ajax if we have a variant ID to work with
      if (id) {
        updateQuantity(id, qty);
      }
    });

    // Highlight the text when focused
    qtyInput.off('focus');
    qtyInput.on('focus', function() {
      var el = $(this);
      setTimeout(function() {
        el.select();
      }, 50);
    });

    // Completely remove product
    $('.ajaxcart__remove').on('click', function(e) {
      var el = $(this),
          id = el.data('id') || null,
          qty = 0;

      // Without an id, let the default link action take over
      if (!id) {
        return;
      }

      e.preventDefault();
      updateQuantity(id, qty);
    });

    function updateQuantity(id, qty) {
      // Add activity classes when changing cart quantities
      if (!settings.useCartTemplate) {
        var row = $('.ajaxcart__row[data-id="' + id + '"]').addClass('is-loading');
      } else {
        var row = $('.cart__row[data-id="' + id + '"]').addClass('is-loading');
      }

      if (qty === 0) {
        row.addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        Shopify.changeItem(id, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    var noteArea = $('textarea[name="note"]');
    noteArea.off('change');
    noteArea.on('change', function() {
      var newNote = $(this).val();

      // Simply updating the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Hide the modal or drawer if we're at 0 items
    if (cart.item_count === 0) {
      // Handle each add to cart method
      switch (settings.method) {
        case 'modal':
          break;
        case 'flip':
        case 'drawer':
          //console.log('about to hide');
          //hideDrawer();
          break;
      }
    }

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      Shopify.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var el = $(this),
            currentQty = el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxifyQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });
    }

    // If there is a regular link to remove an item, add attributes needed to ajaxify it
    if ($('a[href^="/cart/change"]', $cartContainer).length) {
      $('a[href^="/cart/change"]', $cartContainer).each(function() {
        var el = $(this).addClass('ajaxcart__remove');
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var el = $(this),
            currentQty = el.val(),
            inputName = el.attr('name'),
            inputId = el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var el = $(this),
            id = el.data('id'),
            qtySelector = el.siblings('.js-qty__num'),
            qty = parseInt(qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
          qty = qty + 1;
        } else {
          qty = qty - 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  scrollTop = function () {
    
    //console.log('in scroll top');
    
    if ($body.scrollTop() > 0 || $html.scrollTop() > 0) {
      $('html, body').animate({
        scrollTop: 0
      }, 250, 'swing');
    }

  };

  scrollRevert = function () {
    
    /**
     *
     * When the drawer is first activated the scroll position is recorded before the page scrolls to the top.
     * When the drawer closes, the page is positioned back this initial page scroll position
     *
     **/
      
    
    $('html, body').animate({
      scrollTop: scrollPosRevert
    }, 400, 'swing');

  };

  toggleCallback = function (data) {
    // General data to send
    data.method = settings.method;

    // Run the callback if it's a function
    if (typeof settings.onToggleCallback == 'function') {
      settings.onToggleCallback.call(this, data);
    }
  };

  module = {
    init: init
  };

  return module;

}(ajaxifyShopify || {}, jQuery));
